var map = {
	"./header-attachment-gradient.svg": "./src/img/header-attachment-gradient.svg",
	"./header-attachment-light.svg": "./src/img/header-attachment-light.svg",
	"./icon-checks.svg": "./src/img/icon-checks.svg",
	"./icon-strl-white.svg": "./src/img/icon-strl-white.svg",
	"./icon-stuurlui-blue.svg": "./src/img/icon-stuurlui-blue.svg",
	"./icon-stuurlui-global.svg": "./src/img/icon-stuurlui-global.svg",
	"./logo-white-outline.svg": "./src/img/logo-white-outline.svg",
	"./logo-white.svg": "./src/img/logo-white.svg",
	"./logo.svg": "./src/img/logo.svg",
	"./shapes-1-orange.svg": "./src/img/shapes-1-orange.svg",
	"./shapes-1-white.svg": "./src/img/shapes-1-white.svg",
	"./shapes-2-white.svg": "./src/img/shapes-2-white.svg",
	"./shapes-3-white.svg": "./src/img/shapes-3-white.svg",
	"./strl-16px.png": "./src/img/strl-16px.png",
	"./strl-36px.png": "./src/img/strl-36px.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/img sync recursive ^\\.\\/.*$";